// Synthetic Antibody Database Generator with images array and corrected weighted recency
export default function generateAntibodyDatabase(entryCount = 5000) {
  const proteins = ["p53", "EGFR", "Actin", "Tubulin", "HER2", "VEGF", "CDK4", "BCL2", "NF-kB", "PD-L1"];
  const brands = ["Abcam", "Cell Signaling", "Santa Cruz", "Thermo Fisher", "Sigma-Aldrich"];
  const applications = ["Western blot", "Western Blot", "IHC", "ICC"];//, "Flow Cytometry", "ELISA", "ChIP"];
  const cellLines = ["HeLa", "HEK293", "Jurkat", "MCF7", "A549", "CHO", "NIH3T3"];
  const users = ["Alice", "Bob", "Carol", "Dave", "Eve", "Frank", "Grace", "Heidi", "Ivan", "Judy", "Mallory"];
  const dilutions = ["1:100", "1:200", "1:500", "1:1000", "1:2000"];



  window.count = 0;
  // Corrected weighted random date generator
  function weightedRecentDate() {
    const r = Math.random();
    let daysBack;

    
    if (r < 0.7) {
      // 1–5 years ago
      daysBack = Math.floor(365 + Math.random() * (4 * 365));
    } else if (r < 0.9) {
      // 1–12 months ago
      daysBack = Math.floor(30 + Math.random() * (12) * 30);
    } else if (r < 0.999) {
      // 1–4 weeks ago
      daysBack = Math.floor(7 + Math.random() * 28);
    } else {
      console.log(++window.count, "ELSE r = ",r);
      // 1–6 days ago
      daysBack = Math.floor(1 + Math.random() * 6);
    }


    

    const date = new Date();
    date.setDate(date.getDate() - daysBack);

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const finalDate = `${y}-${m}-${d}`;

    //console.log("r = " + r, "daysBack = ", daysBack, finalDate, "|", new Date(finalDate));
    return finalDate;
  }

  const db = [];

  for (let i = 0; i < entryCount; i++) {
    const protein = proteins[Math.floor(Math.random() * proteins.length)];
    const brand = brands[Math.floor(Math.random() * brands.length)];
    const lotNumber = `LOT-${Math.floor(1000 + Math.random() * 9000)}`;
    const availability = Math.random() > 0.2; // 80% available
    const dataAvailable = Math.random() > 0.5;

    // create MANY usage records per antibody
    const numUsages = Math.floor(Math.random() * 50) + 1; // 1–50 usage entries
    const usages = Array.from({ length: numUsages }, (_, idx) => {
      // each usage has 1–3 images
      const numImages = Math.floor(Math.random() * 3) + 1;
      const images = Array.from({ length: numImages }, (__, j) =>
        `https://placehold.co/200x100?text=${protein}+${i}+U${idx}+Img${j}`
      );

      return {
        usedBy: users[Math.floor(Math.random() * users.length)],
        usageDate: weightedRecentDate(),
        application: applications[Math.floor(Math.random() * applications.length)],
        dilution: dilutions[Math.floor(Math.random() * dilutions.length)],
        cellLine: cellLines[Math.floor(Math.random() * cellLines.length)],
        notes: `Auto-generated usage #${idx + 1}`,
        images
      };
    });

    // find most recent usage for antibody
    const sortedUsages = [...usages].sort((a, b) => new Date(b.usageDate) - new Date(a.usageDate));
    const lastUsageDate = sortedUsages[0].usageDate;

    db.push({
      protein,
      brand,
      lotNumber,
      inLabAvailability: availability,
      inLabDataAvailability: dataAvailable,
      lastUsageDate, // for React table sorting & relative display
      usages
    });
  }

  return db;
}
